import ContentTauron from './contentTauron';

export default ContentTauron;
